import styled from "styled-components"

export const MarkAsResolvedWrap = styled.div``
